import { DARK_MODE, LIGHT_MODE } from "../constants";

export const darkModeAction = () => ({
    type: DARK_MODE
})

export const lightModeAction = () => ({
    type: LIGHT_MODE
})